import { styled } from '@mui/material';

export const StyledSvg = styled('svg')({
	fill: 'none',
	xmlns: 'http://www.w3.org/2000/svg'
});
